import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  attireCategoryId: Yup.string().required('Dress code type must be selected'),
  title: Yup.string().required('Title cannot be blank'),
  description: Yup.string(),
});
